import { FullScreenPage, Skeleton, Stack } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export function TimeOffRequestLoading() {
  const { t } = useTranslation();

  return (
    <FullScreenPage isCenterVertical={true}>
      <Stack gap={"md"} className={"text-center"}>
        {t("common:loading")}...
        <Skeleton className={"h-5 w-140"} />
      </Stack>
    </FullScreenPage>
  );
}
